import type { CurationListStatus } from "@/features/data-curation/status";
import { cn } from "@/utils/cn";
import { CircleCheck, CircleDot, CirclePause, Loader2 } from "lucide-react";

const ICON = "h-3.5 w-3.5 shrink-0";

export const CurationStatusIcon = ({ status }: { status: CurationListStatus }) => {
  if (status === "working") {
    return <Loader2 className={cn(ICON, "animate-spin text-blue-600")} aria-hidden />;
  }
  if (status === "completed") {
    return <CircleCheck className={cn(ICON, "text-emerald-600")} aria-hidden />;
  }
  if (status === "paused") {
    return <CirclePause className={cn(ICON, "text-zinc-400")} aria-hidden />;
  }
  return <CircleDot className={cn(ICON, "text-amber-600")} aria-hidden />;
};
